<app-dialog-header [title]="'ENGAGE.EDIT_FEATURED.TITLE'" [additionalText]="widgetName" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" *ngIf="!isContentLoading; else spinner">
    <ng-container
        *ngIf="
            {
                totalCount: (scheduledStreamContentStateTotalCount$ | async),
                filteredScheduledStreamContents: (filteredScheduledStreamContent$ | async),
                isFetching: (isFetchingScheduledStreamContenList$ | async)
            } as vm
        "
    >
        <ng-container
            *ngIf="
                !isBaseContentEmpty ||
                vm.filteredScheduledStreamContents?.length > 0 ||
                (searchInput.value || '').trim() ||
                postingTypeInput.value ||
                isResettingSearch ||
                vm.isFetching;
                else noContent
            "
        >
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-24">
                <div fxLayout="row">
                    <app-search-outline class="mr-8" [searchInput]="searchInput"></app-search-outline>

                    <mat-form-field appearance="outline" class="w-200 mr-8 hide-subscript-wrapper">
                        <mat-label>{{ 'GENERAL.LABEL.FILTER_BY_TYPE' | translate }}</mat-label>
                        <mat-select #postingTypeSelect [formControl]="postingTypeInput">
                            <mat-option [value]="null">
                                {{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}
                            </mat-option>
                            <mat-option *ngFor="let postingType of postingTypes" [value]="postingType.id">
                                {{ postingType.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <app-white-button [icon]="'add'" [label]="'GENERAL.LABEL.ADD_CONTENT'" (onClick)="openAddFeaturedContentDialog()"></app-white-button>
            </div>

            <div class="bg-zinc-50 py-8 px-16 mb-24" fxLayout="column" fxLayoutAlign="flex-start center" *ngIf="liveCategoryLinks.length">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="w-full">
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mr-8">
                        <mat-icon class="mr-8 text-gray-500">link</mat-icon>
                        <h3 class="text-gray-600 text-base font-medium my-0 rounded-sm">
                            {{ 'LIVE_CATEGORY_LINK.TITLE.PLURAL' | translate }}
                        </h3>
                    </div>

                    <button mat-icon-button (click)="toggleLiveCategoryLinks()">
                        <mat-icon class="text-gray-600 cursor-pointer">
                            {{ isLiveCategoryLinksExpanded ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </button>
                </div>

                <div *ngIf="isLiveCategoryLinksExpanded" class="w-full">
                    <mat-chip-set class="chip-list wrap">
                        <mat-chip
                            class="chip maxbrain-500 relative"
                            *ngFor="let liveCategoryLink of liveCategoryLinks"
                            [matTooltip]="liveCategoryLink.category.breadcrumbs"
                            matTooltipPosition="above"
                        >
                            {{ liveCategoryLink.category.name }}
                            <mat-icon matChipRemove (click)="onDeleteLiveCategoryLink(liveCategoryLink)">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-set>
                </div>
            </div>

            <app-scheduled-stream-content-list
                [style.display]="((searchInput.value || '').trim() || postingTypeInput.value) && !vm.isFetching && !(vm.filteredScheduledStreamContents?.length > 0) ? 'none' : null"
                [filteredScheduledStreamContent$]="filteredScheduledStreamContent$"
                [scheduledStreamContentStateSearchTerm$]="scheduledStreamContentStateSearchTerm$"
                [scheduledStreamContentStateTotalCount$]="scheduledStreamContentStateTotalCount$"
                [loadScheduledStreamContent$]="loadScheduledStreamContent$"
                [audienceId]="audienceId"
                [featuredStreamContentId]="featuredStreamContentId"
                [selectedPostingTypeId]="selectedPostingTypeId"
            ></app-scheduled-stream-content-list>

            <div
                *ngIf="((searchInput.value || '').trim() || postingTypeInput.value) && !vm.isFetching && !(vm.filteredScheduledStreamContents?.length > 0)"
                fxLayout="column"
                fxLayoutAlign="center center"
                class="no-search-results-container py-48"
            >
                <mat-icon class="participant-view-illustration" svgIcon="search_no_results_2"></mat-icon>
                <h2 class="mt-8 mb-0 text-base">
                    {{ 'GENERAL.LABEL.NO_RESULTS' | translate }}
                </h2>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #noContent>
        <div class="no-content-state py-48" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="participant-view-illustration" svgIcon="opened_folder_2"></mat-icon>
            <h3 class="my-16">{{ 'CONTENT.TITLE.NO_CONTENT' | translate }}</h3>
            <app-flat-button [icon]="'add'" [label]="'GENERAL.LABEL.ADD_CONTENT'" (onClick)="openAddFeaturedContentDialog()"></app-flat-button>
        </div>
    </ng-template>
</div>
<ng-template #spinner>
    <div class="p-24 white" fxLayout="column" fxLayoutAlign="center center">
        <div class="p-24">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-template>
